import { getAllGlobalCollectionItems, loadAllCollectionItems } from "@pages/CollectionsPage/hooks/useGlobalCollectionItems";
import { SelectInputData } from "../../../../../components/deprecated/SelectInputField/SelectInputField";
import { CompanyCollectionItemData } from "../../../Company/Collections/CompanyCollectionItemData";
import { PropertyCollectionItemData } from "../../../Property/Collections/PropertyCollectionItemData";
import { CollectionData } from "../../../collections/CollectionData";
import { GenericCollectionItemType, GenericCollectionType } from "../../DataObjectHelpers/Property/CollectionItemDataHelper";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { V2CollectionItemData } from "../../V2CollectionItemData";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataCollectionItemFields<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  GenericCollectionItemType,
  FirebaseDataType
> {
  companyID: string | undefined;
  propertyID: string | undefined;
  collectionID: string | undefined;

  constructor(
    companyID: string | undefined,
    propertyID: string | undefined,
    collectionID: string | undefined,
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => GenericCollectionItemType | GenericCollectionItemType[] | undefined,
    iconName?: string
  ) {
    super(key, title, dataGetter, iconName, true);
    this.companyID = companyID;
    this.propertyID = propertyID;
    this.collectionID = collectionID;
  }

  private getCollection = (): GenericCollectionType | undefined => {
    if (this.companyID) return LocalData.companies.getData(this.companyID)?.collections.getData(this.collectionID);
    if (this.propertyID) return LocalData.properties.getData(this.propertyID)?.collections.getData(this.collectionID);
    return undefined;
  };

  encode = (value: GenericCollectionItemType) => value.id;
  override convertValueToSelectInput(value: GenericCollectionItemType): SelectInputData {
    return new SelectInputData(value.id + "", value.name);
  }

  getValueForKey(key: string): GenericCollectionItemType | undefined {
    return this.getCollection()?.items.addData(key);
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return this.getCollection()?.items.documents.map((data) => ({ key: data.id, label: data.name })) ?? [];
  }
  getReadableStringRepresentation(value: GenericCollectionItemType): string {
    return value.name;
  }

  override isValueValid = (value: any): boolean => {
    return value instanceof PropertyCollectionItemData || value instanceof CompanyCollectionItemData;
  };
}

export class DataObjectCollectionItemField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<
  V2CollectionItemData,
  FirebaseDataType
> {
  collection: CollectionData | undefined;
  constructor(
    collection: CollectionData | undefined,
    key: string,
    title: string,
    dataGetter: (data: FirebaseDataType) => V2CollectionItemData[] | undefined,
    iconName?: string
  ) {
    super(key, title, dataGetter, iconName, false);
    this.collection = collection;
  }

  encode = (value: V2CollectionItemData) => value.id;
  override convertValueToSelectInput(value: V2CollectionItemData): SelectInputData {
    return new SelectInputData(value.id + "", value.name);
  }
  getValueForKey(key: string): V2CollectionItemData | undefined {
    return LocalData.collectionItems.addData(key);
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    return getAllGlobalCollectionItems(this.collection).map((data) => ({ key: data.id, label: data.name })) ?? [];
  }
  getReadableStringRepresentation(value: V2CollectionItemData): string {
    return value.name;
  }

  override loadAllDatas(): Promise<any> {
    if (!this.collection) return Promise.resolve();
    return loadAllCollectionItems(this.collection);
  }

  isValueValid(value: any): boolean {
    return value instanceof V2CollectionItemData;
  }
}
